import * as React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";

interface IProps {
    article: {
        author?: {
            name: string;
            description: string;
        };
        create_date: string;
        date_published: string | null;
        date_content_changed: string;
        gallery: (
            | {
                  image: {
                      g_img_1160x638: string;
                  } | null;
              }
            | undefined
        )[];
        id: number;
        lead: string | null;
        ratings: {
            total: number;
            average: number | null;
        };
        slug: string;
        title: string;
        update_date: string;
    };
}

export const SchemaArticleDetail: React.FunctionComponent<IProps> = (props) => {
    const url = rpAppLink.article.detail({articleId: props.article.id, articleSlug: props.article.slug});
    const firstGalleryItem = props.article.gallery[0];
    const averageRatingValue = props.article.ratings.average && props.article.ratings.average >= 4 ? props.article.ratings.average : null;
    const aggregateRatingValue = {
        "@type": "AggregateRating",
        bestRating: "5",
        ratingCount: props.article.ratings.total,
        ratingValue: averageRatingValue
    };
    const aggregateRating = averageRatingValue && aggregateRatingValue;

    const json = {
        "@context": "http://schema.org/",
        "@type": "CreativeWorkSeries",
        author: {
            name: props.article.author && props.article.author.name,
            description: props.article.author && props.article.author.description
        },
        name: props.article.title,
        headline: props.article.title,
        description: props.article.lead,
        dateCreated: formatDate(props.article.create_date, dateTimeFormat.dashedDateFormat),
        datePublished: props.article.date_published,
        dateModified: formatDate(props.article.date_content_changed, dateTimeFormat.dashedDateFormat),
        image: {
            "@type": "ImageObject",
            url: firstGalleryItem && firstGalleryItem.image && firstGalleryItem.image.g_img_1160x638,
            height: 638,
            width: 1160
        },
        publisher: {
            "@type": "Organization",
            name: "Rynek Pierwotny",
            logo: {
                "@type": "ImageObject",
                url: `${rpCommonUrl}/static-rp-old/img/logo_rp_340x86.jpg`,
                width: 340,
                height: 86
            }
        },
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        aggregateRating
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import * as React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";

interface IProps {
    article: {
        author?: {
            name: string;
            description: string;
        };
        create_date: string;
        date_published: string | null;
        date_content_changed: string;
        gallery: (
            | {
                  image: {
                      g_img_1160x638: string;
                  } | null;
              }
            | undefined
        )[];
        id: number;
        lead: string | null;
        ratings: {
            total: number;
            average: number | null;
        };
        slug: string;
        title: string;
        update_date: string;
    };
}

export const SchemaArticleDetail: React.FunctionComponent<IProps> = (props) => {
    const url = rpAppLink.article.detail({articleId: props.article.id, articleSlug: props.article.slug});
    const firstGalleryItem = props.article.gallery[0];
    const averageRatingValue = props.article.ratings.average && props.article.ratings.average >= 4 ? props.article.ratings.average : null;
    const aggregateRatingValue = {
        "@type": "AggregateRating",
        bestRating: "5",
        ratingCount: props.article.ratings.total,
        ratingValue: averageRatingValue
    };
    const aggregateRating = averageRatingValue && aggregateRatingValue;

    const json = {
        "@context": "http://schema.org/",
        "@type": "CreativeWorkSeries",
        author: {
            name: props.article.author && props.article.author.name,
            description: props.article.author && props.article.author.description
        },
        name: props.article.title,
        headline: props.article.title,
        description: props.article.lead,
        dateCreated: formatDate(props.article.create_date, dateTimeFormat.dashedDateFormat),
        datePublished: props.article.date_published,
        dateModified: formatDate(props.article.date_content_changed, dateTimeFormat.dashedDateFormat),
        image: {
            "@type": "ImageObject",
            url: firstGalleryItem && firstGalleryItem.image && firstGalleryItem.image.g_img_1160x638,
            height: 638,
            width: 1160
        },
        publisher: {
            "@type": "Organization",
            name: "Rynek Pierwotny",
            logo: {
                "@type": "ImageObject",
                url: `${rpCommonUrl}/static-rp-old/img/logo_rp_340x86.jpg`,
                width: 340,
                height: 86
            }
        },
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        aggregateRating
    };
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
